__turbopack_context__.v({
  "aura": "login-transition-module__ktxXHW__aura",
  "auraCore": "login-transition-module__ktxXHW__auraCore",
  "auraEdge": "login-transition-module__ktxXHW__auraEdge",
  "center": "login-transition-module__ktxXHW__center",
  "horizon": "login-transition-module__ktxXHW__horizon",
  "light": "login-transition-module__ktxXHW__light",
  "line": "login-transition-module__ktxXHW__line",
  "logo": "login-transition-module__ktxXHW__logo",
  "lt-aura-flash": "login-transition-module__ktxXHW__lt-aura-flash",
  "lt-aura-grow": "login-transition-module__ktxXHW__lt-aura-grow",
  "lt-aura-pulse": "login-transition-module__ktxXHW__lt-aura-pulse",
  "lt-draw": "login-transition-module__ktxXHW__lt-draw",
  "lt-edge-flash": "login-transition-module__ktxXHW__lt-edge-flash",
  "lt-fill": "login-transition-module__ktxXHW__lt-fill",
  "lt-in": "login-transition-module__ktxXHW__lt-in",
  "lt-leave": "login-transition-module__ktxXHW__lt-leave",
  "lt-leave-content": "login-transition-module__ktxXHW__lt-leave-content",
  "lt-out": "login-transition-module__ktxXHW__lt-out",
  "lt-rise": "login-transition-module__ktxXHW__lt-rise",
  "lt-scan": "login-transition-module__ktxXHW__lt-scan",
  "lt-scan-done": "login-transition-module__ktxXHW__lt-scan-done",
  "lt-text": "login-transition-module__ktxXHW__lt-text",
  "overlay": "login-transition-module__ktxXHW__overlay",
  "status": "login-transition-module__ktxXHW__status",
  "track": "login-transition-module__ktxXHW__track",
});
